import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#F7F9F9',
        transition: '0.3s',
        width: 345,
        margin: 10,
        '&:hover': {
            backgroundColor: '#c4c7c7f4',
            color: '#000000',
            cursor: 'pointer'
        }
    }
}))